import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';

class AudianceAnalyticsDountchart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // series: [20, 30, 25, 25,],
            options: {
                chart: {
                    height: 300,
                    type: 'donut',
                    // toolbar: {
                    //     show: false
                    // }
                },
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'center',
                    show: true,
                },
                labels: ['Excisting Customer','New Customer'],
                fill: {
                    colors: props.donutChartColors,
                    // ['#9237B3', '#45F073',]
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                stroke: {
                    show: false,
                    width: 0
                },
            },
            series: [35, 65,],
        };
    }
    render() {
        return (
            <ReactApexChart
                options={this.state.options}
                series={this.state.series}
                type="donut"
                height={250}
            />
        );
    }
}

export default AudianceAnalyticsDountchart;
